import React from 'react'
import { Typography, Grid} from '@mui/material';
import colors from '../../../../colors'
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';



const SingleContract = (props) => 
{  
    return( 
        <Grid container item md={12} xs={12} >
        <ListItemButton sx={{width:props.utilityName === '' ? '30vw' : '20vw', borderRadius:'20px', '@media (max-width: 899px)' : {width:'70vw'}}} onClick={props.onClick}>
            <ListItemIcon style={{paddingRight:'5%'}}>
                <Grid>
                    <img src={props.contractData.logoPath} width={'50rem'} />
                </Grid>
            </ListItemIcon>
            <ListItemText disableTypography={true} primary={<Typography sx={{fontSize:'1.1rem', fontFamily:'GerberaBold', color:colors.darkBlue}} >{props.contractData.contract === '' ? props.contractData.optional : props.contractData.contract}</Typography>} secondary={Object.entries(props.contractData).slice(3, Object.entries(props.contractData).length).map(([key, value], index) => {
                {
                   return <div style={{fontFamily:'GerberaLight', color:colors.gray}} key={index}>{value}</div> 
                }
            })} />                 
        </ListItemButton>
    </Grid>
    )
}
export default SingleContract